import React, { useState, useEffect } from 'react';
import ProtectedRoute from '../../routes/protected';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Toast } from 'primereact/toast';
import UsePerms from '../../context/userAccess';
import useCompanyData from '../../context/company';
import surveyService from '../../services/data/survey.service';
import SurveyPageHeader from './SurveyPageHeader';
import { richTextToPlainPreview } from '../../helpers/richText';

export default function SurveyTemplateList() {
    const navigate = useNavigate();
    const toast = React.useRef(null);
    const VerifyPerms = UsePerms();
    const { rootUser } = useCompanyData();
    const companyId = localStorage.getItem('companyId');
    const canCreateTemplate = VerifyPerms(['add_surveytemplate']) || rootUser;
    const [templates, setTemplates] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!companyId) return;
        setLoading(true);
        surveyService.listTemplates({ company_id: companyId })
            .then(r => setTemplates(r || []))
            .catch(err => {
                if (toast.current) toast.current.show({ severity: 'error', summary: 'Erro', detail: err.response?.data?.detail || 'Falha ao carregar templates' });
            })
            .finally(() => setLoading(false));
    }, [companyId]);

    function formatCreated(iso) {
        if (!iso) return '—';
        return new Date(iso).toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    }

    return (
        <ProtectedRoute>
            <Toast ref={toast} position="top-right" />
            <div className="container-fluid">
                <SurveyPageHeader title="Templates de Pesquisa" />
                <div className="my-4 mx-5 py-3 rounded-top" style={{ minHeight: '500px' }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 className="text-default mb-0">
                        <FontAwesomeIcon icon={solid('file-lines')} className="me-2 text-green" />
                        Lista de templates
                    </h5>
                    {canCreateTemplate && (
                        <button className="btn btn-success btn-rounded btn-sm px-3" onClick={() => navigate('/survey/template/create/')}>
                            <FontAwesomeIcon icon={solid('plus')} className="me-1" /> Novo Template
                        </button>
                    )}
                </div>

                <div className="bg-white rounded border-clean p-3">
                    {loading ? (
                        <div className="text-center py-5 text-muted">Carregando...</div>
                    ) : templates.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                            Nenhum template cadastrado.
                            {canCreateTemplate && <a href="/survey/template/create/"> Criar primeiro template</a>}
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <table className="table table-hover">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Descrição</th>
                                        <th>Criado por</th>
                                        <th className="text-center">Criado em</th>
                                        <th className="text-center">Perguntas</th>
                                        <th className="text-center">Versão</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {templates.map((t) => (
                                        <tr key={t.id} className="align-middle">
                                            <td><a href={`/survey/template/${t.id}/`} className="text-green fw-bold text-decoration-none">{t.name}</a></td>
                                            <td className="text-muted small">{richTextToPlainPreview(t.description) || '—'}</td>
                                            <td className="small">{t.created_by_name || '—'}</td>
                                            <td className="text-center small">{formatCreated(t.created)}</td>
                                            <td className="text-center">{t.questions_count ?? 0}</td>
                                            <td className="text-center">v{t.version}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
                </div>
            </div>
        </ProtectedRoute>
    );
}
